import { useState } from "react";
import { Building2, LogIn, Plus } from "lucide-react";
import { LinkOrgModal, CreateOrgModal } from "./OrgDialogs";

// Shown when the signed-in user belongs to NO organization (e.g. they left their last one). The app's
// data is entirely org-scoped, so there's nothing to show until they link or create one. The header's
// profile menu (link / create / log out) stays available above this.
export function NoOrgGate() {
  const [modal, setModal] = useState<"link" | "create" | null>(null);
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-lg border border-line bg-raised p-6 text-center">
        <Building2 size={32} className="mx-auto mb-3 text-faint" />
        <h2 className="mb-1 text-base font-semibold text-fg">
          You're not in an organization
        </h2>
        <p className="mb-4 text-[13px] text-muted">
          Fields and maps live inside an organization. Link one with its join
          code, or create your own to get started.
        </p>
        <div className="flex flex-col gap-2">
          <button
            className="flex items-center justify-center gap-1.5 rounded bg-accent px-3 py-2 text-sm font-medium text-canvas hover:bg-accent-hover"
            onClick={() => setModal("link")}
          >
            <LogIn size={14} /> Link an organization
          </button>
          <button
            className="flex items-center justify-center gap-1.5 rounded border border-line px-3 py-2 text-sm text-fg hover:bg-hover"
            onClick={() => setModal("create")}
          >
            <Plus size={14} /> Create an organization
          </button>
        </div>
      </div>
      {modal === "link" && <LinkOrgModal onClose={() => setModal(null)} />}
      {modal === "create" && <CreateOrgModal onClose={() => setModal(null)} />}
    </div>
  );
}
